import { createPortal } from 'react-dom';
import './confirmation-modal.css';

function ConfirmationModal({ show, title, description, onConfirm = () => {}, onClose = () => {} }) {
    if (!show)
        return null;

    return createPortal(
        <>
            <div className="confirmation-modal-overlay show" onClick={onClose}></div>
            <div className="confirmation-modal show">
                <h1>{title}</h1>

                <h3>{description}</h3>

                <div className='confirmation-modal-buttons'>
                    <button className='gray-button' onClick={() => onClose()}>Cancelar</button>
                    <button className='blue-button zoom-effect' onClick={() => onConfirm()}>Confirmar</button>
                </div>
            </div>
        </>,
        document.body
    );
}

export default ConfirmationModal;